import PropTypes from 'prop-types';
import React from 'react';

import { mediumUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const BUTTON_LENGTH = 30;

const NumberStepper = ({ value, onStepUp, onStepDown, ariaLabel }) => (
  <div className="NumberStepper">
    <button
      className="NumberStepper__button NumberStepper__button--step-down"
      onClick={() => onStepDown(value - 1)}
    >
      {I18n.localize('numberStepper.decrement')}
    </button>
    <span className="NumberStepper__value" aria-label={ariaLabel}>
      {value}
    </span>
    <button
      className="NumberStepper__button NumberStepper__button--step-up"
      onClick={() => onStepUp(value + 1)}
    >
      {I18n.localize('numberStepper.increment')}
    </button>

    <style jsx>
      {`
        .NumberStepper {
          display: flex;
          align-items: center;
          border: 2px solid ${Theme.get('colors-black-20')};
        }

        .NumberStepper__button {
          position: relative;
          display: block;
          appearance: none;
          border: none;
          text-align: center;
          padding: 0;
          margin: 0;
          text-indent: -9999em;
          width: ${Theme.get('spacing') * 4}px;
          height: ${Theme.get('spacing') * 4}px;
          min-width: ${Theme.get('spacing') * 4}px;
          background-color: ${Theme.get('colors-white')};
          outline: none;
        }

        @media ${mediumUp} {
          .NumberStepper__button {
            width: ${BUTTON_LENGTH}px;
            height: ${BUTTON_LENGTH}px;
            min-width: ${BUTTON_LENGTH}px;
          }
        }

        .NumberStepper__button.focused {
          outline: 2px solid ${Theme.get('colors-black')};
        }

        .NumberStepper__button:hover {
          cursor: pointer;
        }

        .NumberStepper__button:hover:before,
        .NumberStepper__button:hover:after,
        .NumberStepper__button.focused:before,
        .NumberStepper__button.focused:after {
          background-color: ${Theme.get('colors-black')};
        }

        .NumberStepper__button:before,
        .NumberStepper__button:after {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          content: '';
          display: block;
          background-color: ${Theme.get('colors-black-20')};
          transition: background-color linear ${Theme.get('transition-duration-ms')};
        }

        .NumberStepper__button--step-down:before {
          height: 2px;
          width: 10px;
        }
        .NumberStepper__button--step-up {
          align-self: flex-end;
        }
        .NumberStepper__button--step-up:before {
          height: 2px;
          width: 10px;
        }
        .NumberStepper__button--step-up:after {
          height: 10px;
          width: 2px;
        }

        .NumberStepper__value {
          width: 100%;
          min-width: 20px;
          text-align: center;
          user-select: none;
          font-weight: ${Theme.get('font-weight-bold')};
          font-size: ${Theme.get('font-size-small-px')};
          color: ${Theme.get('colors-black')};
        }
      `}
    </style>
  </div>
);

NumberStepper.propTypes = {
  value: PropTypes.number.isRequired,
  onStepUp: PropTypes.func.isRequired,
  onStepDown: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
};

NumberStepper.defaultProps = {
  ariaLabel: null,
};

export default NumberStepper;
